<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="ReceiveDetailModalLabel">Receive Serial List</h5>
      <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <div class="row mt-3 mb-2">
        <div class="col-lg-4 p-r-0 mb-1">
          <input
            type="text"
            class="form-control form-control-sm"
            @keyup.enter="getReceiveSerial()"
            @keyup="search_text === '' ? getReceiveSerial() : ''"
            v-model="search_text"
            placeholder="Please Enter keyword"
          />
        </div>
        <div class="col-lg-2 mb-1">
          <button type="button" class="btn btn-sm waves-effect waves-light btn-light-info text-info" @click="getReceiveSerial()">
            <i class="fa fa-search mr-1"></i> Search
          </button>
        </div>
      </div>
      <div class="row">
        <div class="table-responsive tableFixHead">
          <div class="table-responsive" style="min-height: 30vh;">
            <table class="table customize-table mb-0 v-middle">
              <thead class="table-light">
                <tr>
                  <th class="border-bottom border-top text-center">#</th>
                  <th class="border-bottom border-top text-start">Serial</th>
                  <th class="border-bottom border-top text-start">In Time</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center" colspan="3" v-if="isLoad == true"><i class="fas fa-sync-alt fa-spin fa-2x fa-fw"></i></td>
                </tr>
                <tr v-for="(rs, i) in serialModalList" :key="'rs' + i">
                  <td class="text-center">{{ i + 1 }}</td>
                  <td>{{ rs.prs_serial_no }}</td>
                  <td>{{ rs.prs_in_time != '' ? dateFormatAndTime(rs.prs_in_time) : '-' }}</td>
                </tr>
                <tr v-if="serialModalList.length < 1 && isLoad == false">
                  <td class="text-center" colspan="3">No Data</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary btn-fix" @click="closeModal"><i class="fa fa-times"></i> Close</button>
    </div>
  </div>
</template>

<script>
import api from '../../models/receiveorder'

export default {
  props: ['modalReceiveDetail', 'receiveType'],
  data() {
    return {
      isLoad: false,
      search_text: '',
      serialModalList: []
    }
  },
  methods: {
    closeModal() {
      $('#ReceiveorderSerialModal').modal('hide')
    },
    getReceiveSerial() {
      this.isLoad = true
      this.partstoreModalList = []
      var obj = {
        rec_id: this.modalReceiveDetail.rec_id,
        recd_id: this.modalReceiveDetail.recd_id,
        receive_type: this.receiveType,
        search: this.search_text
      }
      this.header.params = obj
      api.getReceiveSerial(
        this.$store.state.URLHost,
        this.header,
        result => {
          if (result.response === true) {
            this.serialModalList = result.data
          } else {
            this.alert_msg('warning', 'An error occurred.', result.message)
          }
          this.isLoad = false
        },
        error => {
          this.alert_msg('error', 'An error occurred.', error.message)
          this.isLoad = false
        }
      )
    }
  },
  watch: {
    'modalReceiveDetail.recd_id': {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== 0 && newValue !== undefined) {
          this.getReceiveSerial()
        }
      }
    },
    'receiveType': {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== 0 && newValue !== undefined) {
          this.serialModalList = []
          this.getReceiveSerial()
        }
      }
    }
  },
  mounted() {
    $('#ReceiveorderSerialModal').on('show.bs.modal', event => {
      if (event.target.id === 'ReceiveorderSerialModal') {
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/receiveorder_serial_modal.vue